// extracted by mini-css-extract-plugin
export var bgimageContainer = "basicSubPage-module--bgimageContainer--MoEEx";
export var header = "basicSubPage-module--header--D5K1b";
export var mainImageContainer = "basicSubPage-module--mainImageContainer--X75BC";
export var titleContainer = "basicSubPage-module--titleContainer--oppyO";